var _rect, _rect2, _rect3, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYearBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 14,
    width: 6,
    height: 3,
    rx: 1,
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 19,
    width: 6,
    height: 3,
    rx: 1,
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 19,
    width: 6,
    height: 3,
    rx: 1,
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1724 11.6174L7.65132 11.2206C7.20438 10.8803 6.5649 10.9748 6.2355 11.4298L2.57134 16.4915C2.25342 16.9307 2.34337 17.5432 2.77413 17.8724L3.41414 18.3616C3.86855 18.7089 4.52115 18.605 4.84528 18.1338L8.39052 12.9797C8.69289 12.5401 8.5969 11.9406 8.1724 11.6174Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.777 10.1429C11.8176 9.46106 11.1074 9.81629 10.5012 10.3555C10.1241 10.691 9.57201 10.7468 9.17102 10.4403L8.22279 9.71555C7.86813 9.44449 7.73859 8.97229 7.87398 8.54693C8.21308 7.48166 8.54426 5.97623 8.18601 5.24606C7.82114 4.50241 6.44522 4.46239 5.43822 4.57573C5.08432 4.61556 4.74032 4.40429 4.64874 4.06013C4.55771 3.71807 4.74816 3.36055 5.09034 3.26996C8.80312 2.28707 11.2814 4.23392 12.6025 5.17992L15.0168 6.74572C15.513 7 13.2608 10.5556 12.777 10.1429Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5236 10.323L15.8998 8.22724C16.1842 7.79423 16.7649 7.67225 17.1994 7.95426C17.6398 8.24006 17.7614 8.83082 17.4696 9.26729L16.0764 11.3518C15.7732 11.8052 15.1471 11.9023 14.7208 11.5619C14.3451 11.2618 14.2596 10.725 14.5236 10.323Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYearBuilding);
export default __webpack_public_path__ + "static/media/year_building.943fdbc13d573e5e0120cfc0f93ee2fa.svg";
export { ForwardRef as ReactComponent };